// NUEVO CON COMPONENTES CAMERA
import React, { useEffect, useState, useCallback } from 'react';
import { FaBus, FaGift, FaFileInvoice, FaVideo, FaFileImport, FaFileExport, FaFileAlt, FaMapMarkedAlt } from 'react-icons/fa';
import { BeatLoader } from 'react-spinners';
import CustomNavbar from '../components/Navbar'; // Navbar para colaboradores
// import SidebarLayout from '../layouts/SidebarLayout'; // ⚠️ NO SE USA - Solo para /administrador
import EmployeeCard from '../components/Card';
import PendingTasksCard from '../components/PendingTasksCard';
import HomeHero from '../components/HomeHero';
import { getActiveBanners } from '../components/HomeHero/config/bannersData';
import { Container, Row, Col, Alert, Tabs, Tab, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import BubbleButton from '../components/BubbleButton'
import 'react-toastify/dist/ReactToastify.css';
import '../styles/home.css';
import TalleModalButton from '../components/TalleModalButton';
import { usePermisos } from '../hooks/usePermisos';
import { openHeatmap, HEATMAP_CONFIG, HEATMAP_PERMISSION } from '../config/heatmap.config';

// En desarrollo usar backend local, en producción usar proxy
const API_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:4005' 
  : '';

const AccessCard = ({ icon: Icon, color, title, hint, onClick }) => (
  <Col xs={12} md={6} lg={4} className="mb-3">
    <Card
      className="option-card"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <Card.Body className="d-flex align-items-center">
        <span className="tile-icon" style={{ '--tile': color }}><Icon aria-hidden="true" /></span>
        <div className="tile-text">
          <h5>{title}</h5>
          <p>{hint}</p>
        </div>
      </Card.Body>
    </Card>
  </Col>
);

const Init = () => {
  const [userData, setUserData] = useState(null);
  const [token, setToken] = useState(null);
  const [recibos, setRecibos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('recibos');
  const [informePendiente, setInformePendiente] = useState(null);
  const navigate = useNavigate();
  
  // Usar nuevo sistema de permisos
  const { tienePermiso, loading: permisosLoading } = usePermisos();
  

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedToken = localStorage.getItem('token');

    if (!storedUser || !storedToken) {
      navigate('/');
      return;
    }

    setUserData(JSON.parse(storedUser));
    setToken(storedToken);
    
    // Obtener CUIL del empleado si no está en los datos guardados
    const fetchCUIL = async () => {
      try {
        const parsedUser = JSON.parse(storedUser);
        if (!parsedUser.CUIL && parsedUser.Legajo) {
          const response = await fetch(`${API_URL}/api/empleados/${parsedUser.Legajo}`, {
            headers: {
              'Authorization': `Bearer ${storedToken}`,
              'Content-Type': 'application/json'
            }
          });
          
          if (response.ok) {
            const empleado = await response.json();
            const updatedUser = { ...parsedUser, CUIL: empleado.CUIL };
            setUserData(updatedUser);
            localStorage.setItem('user', JSON.stringify(updatedUser));
          }
        }
      } catch (error) {
        console.error('Error obteniendo CUIL:', error);
      }
    };
    
    fetchCUIL();
  }, [navigate]);

  const fetchRecibos = useCallback(async () => {
    if (!userData || !token) {
      setError('No se encontraron datos del usuario o token.');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const response = await fetch(
        `${API_URL}/api/recibos/mis-recibos`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 401) {
        console.error('Token inválido o expirado');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/');
        return;
      }

      if (!response.ok) {
        throw new Error(`Error al obtener recibos: ${response.statusText} (${response.status})`);
      }

      const data = await response.json();
      setRecibos(data.data || data);
    } catch (err) {
      console.error('Error fetching recibos:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [userData, token, navigate]);

  useEffect(() => {
    if (userData && token) {
      fetchRecibos();
    }
  }, [userData, token, fetchRecibos]);

  const handleDocumentsComplete = (result) => {
    // Documentos completados
  };

  const handleNavigate = (path) => {
    navigate(path);
  };


  if (loading || permisosLoading) {
    return (
      <div className="loading-container">
        <div className="bus-loading">
          <FaBus className="pink-bus-icon" />
          <BeatLoader color="#ff00b3" size={15} />
        </div>
      </div>
    );
  }

  const mostrarInformes = informePendiente || tienePermiso('CARGAINF') || tienePermiso('INFOPEN') || tienePermiso('VERINF') || tienePermiso('VERINFCONF');
  const mostrarInspeccion = tienePermiso('VERDIAG') || tienePermiso(HEATMAP_PERMISSION);
  return (
    <div className="init-container">
      <CustomNavbar userData={userData} />
      
      <Container className="main-content py-4">
        <Row className="justify-content-center mb-4">
          <Col xs={12} className="text-center">
            <div className='title_init'>
              <h2 className='welc'>Bienvenido a</h2>
              <h2 className='color_empresa'> SiBus</h2>
            </div>
          </Col>
        </Row>

        {/* HomeHero - Banner principal */}
        <Row className="justify-content-center mb-4">
          <Col xs={12}>
            <HomeHero 
              banners={getActiveBanners()} 
              options={{
                autoplay: true,
                interval: 8000,
                pauseOnHover: true,
                loop: true
              }}
            />
          </Col>
        </Row>

        {/* Cards de información del usuario */}
        <Row className="justify-content-center mb-4">
          <Col xs={12} lg={6} className="mb-3">
            {userData && <EmployeeCard userData={userData} />}
          </Col>
          {/* PENDIENTES DEL USUARIO */}
          <Col xs={12} lg={6} className="mb-3">
            {userData && <PendingTasksCard userData={userData} />}
          </Col>
        </Row>

        {/* Accesos rápidos agrupados por tipo */}
        <section className="home-grupo" aria-labelledby="grupo-espacio">
          <h3 className="home-grupo-titulo grupo-personal" id="grupo-espacio">Mi espacio</h3>
          <Row>
            <AccessCard icon={FaGift} color="#ff00b3" title="Beneficios" hint="Descuentos y convenios" onClick={() => handleNavigate('/home/beneficios')} />
            <AccessCard icon={FaVideo} color="#0066ff" title="Capacitaciones" hint="Cursos y evaluaciones" onClick={() => handleNavigate('/home/ver-capacitaciones')} />
            <AccessCard icon={FaFileInvoice} color="#ff00b3" title="Recibos" hint="Tus recibos de sueldo" onClick={() => handleNavigate('/home/recibos')} />
          </Row>
        </section>

        {mostrarInformes && (
          <section className="home-grupo" aria-labelledby="grupo-informes">
            <h3 className="home-grupo-titulo grupo-informes" id="grupo-informes">Informes</h3>
            <Row>
              {informePendiente && (
                <AccessCard icon={FaFileImport} color="#f08a00" title="Responder Informe" hint="Tenés un informe para responder" onClick={() => handleNavigate(`/home/descargo/${informePendiente.id}`)} />
              )}
              {tienePermiso('CARGAINF') && (
                <AccessCard icon={FaFileExport} color="#ff6b35" title="Generar Informe" hint="Cargar un informe nuevo" onClick={() => handleNavigate('/home/informes')} />
              )}
              {tienePermiso('INFOPEN') && (
                <AccessCard icon={FaFileImport} color="#ff6b35" title="Informes Pendientes" hint="Informes para validar" onClick={() => handleNavigate('/home/ver-informes-encargado')} />
              )}
              {tienePermiso('VERINF') && (
                <AccessCard icon={FaFileExport} color="#ff6b35" title="Informes a Corregir" hint="Devueltos por el encargado" onClick={() => handleNavigate('/home/ver-informes-devueltos')} />
              )}
              {tienePermiso('VERINFCONF') && (
                <AccessCard icon={FaFileImport} color="#ff6b35" title="Informes" hint="Aprobar o desestimar" onClick={() => handleNavigate('/home/ver-informes-confirmados')} />
              )}
            </Row>
          </section>
        )}

        {mostrarInspeccion && (
          <section className="home-grupo" aria-labelledby="grupo-inspeccion">
            <h3 className="home-grupo-titulo grupo-inspeccion" id="grupo-inspeccion">Inspección y herramientas</h3>
            <Row>
              {tienePermiso('VERDIAG') && (
                <AccessCard icon={FaFileAlt} color="#14a38b" title="Mis Diagramas" hint="Diagramación de inspección" onClick={() => handleNavigate('/home/mis-diagramas')} />
              )}
              {tienePermiso(HEATMAP_PERMISSION) && (
                <AccessCard icon={FaMapMarkedAlt} color="#764ba2" title={HEATMAP_CONFIG.title} hint={HEATMAP_CONFIG.subtitle} onClick={() => openHeatmap()} />
              )}
            </Row>
          </section>
        )}

        {error && (
          <Row className="mb-4">
            <Col xs={12}>
              <Alert variant="danger" className="text-center">
                {error}
              </Alert>
            </Col>
          </Row>
        )}

        {!error && (
          <>
            <Tabs
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              className="mb-3 custom-tabs"
            >
            </Tabs>
          </>
        )}
        
      </Container>
      <div className="floating-buttons">
        <TalleModalButton user={userData} />
      </div>
    </div>
  );
};

export default Init;
